import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { cosemApi } from '@services/providers/cosem';
import { authSlice } from '@features/auth';
import { menuSlice } from '@features/menu';
const persistConfig = {
    key: 'cosem',
    storage,
    whitelist: ['authentication', 'menu']
};

const rootReducer = combineReducers({
    authentication: authSlice.reducer,
    menu: menuSlice.reducer,
    [cosemApi.reducerPath]: cosemApi.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        }).concat(cosemApi.middleware)
});

export type AppStore = typeof store;

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
